import { getPdpShopId } from '../graphql/pdp-shop-id';

export const usePdpShopId = () => {
  const fetchShopId = async (catalogProductId: string) => {
    try {
      const { data } = await getPdpShopId({ catalog_product_id: catalogProductId });
      if (data?.catalog_product_base_info?.shop?.id) {
        return Number(data.catalog_product_base_info.shop.id);
      }
    } catch (e) {
      console.log(e);
    }
    return undefined;
  };

  return { fetchShopId };
};
